module.exports = __webpack_public_path__ + "static/media/logo_esl_gsa.73f22857.png";